"use client";
import React from "react";
import BUIContext from "../components/BUIProvider/BUIProvider.context.js";
const useLocale = () => {
    const { locale } = React.useContext(BUIContext);
    return locale;
};
export default useLocale;
